"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Weight = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Weight = function Weight(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 64,
    height: 40,
    viewBox: "0 0 64 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.444 15.121c.457.21.664.73.5 1.205l-5.202 14.987a1.027 1.027 0 01-1.366.607C52.219 30.6 42.109 26.735 32 26.735c-10.11 0-20.22 3.865-23.376 5.185a1.027 1.027 0 01-1.367-.607l-5.2-14.987a.965.965 0 01.499-1.205C5.846 13.608 18.923 8 32 8c13.076 0 26.153 5.608 29.444 7.121zM32.76 9.88c3.194.046 6.292.377 9.187.87l-.446 2.702a.96.96 0 00.805 1.108.989.989 0 001.122-.815l.435-2.642a75.56 75.56 0 019.116 2.43l-.988 2.473a.94.94 0 00.55 1.237 1.002 1.002 0 001.27-.565l1.002-2.506c3.416 1.237 5.469 2.26 5.469 2.26l-4.876 13.583s-4.552-2.091-11.007-3.61l1.325-5.105c.123-.474-.114-.957-.577-1.116-2.41-.832-10.114-3.052-20.129-1.558-9.808 1.464-16.132 4.236-18.213 5.255a.948.948 0 00-.321.255l-2.766-7.704s2.025-1.009 5.398-2.235l.991 2.48c.2.498.768.751 1.27.566a.94.94 0 00.551-1.237l-.978-2.449a75.625 75.625 0 019.108-2.438l.433 2.626a.99.99 0 001.122.815.96.96 0 00.805-1.108l-.444-2.69a60.588 60.588 0 018.835-.874v2.758a.975.975 0 101.95 0V9.88z",
    fill: "#97BA1E"
  }));
};

exports.Weight = Weight;
var _default = Weight;
exports.default = _default;